import React from 'react';
import { Button } from '@pwc/pwc-deals-ui';

import { useTranslation } from 'react-i18next';

import ReportLayoutIcon from './ReportLayoutIcon';

const ReportLayoutButton = ({ onClick, layoutType }) => {
  const { t } = useTranslation();
  return (
    <Button
      className="ui-button button-no-underline report_layout-button"
      onClick={onClick}
      type="button"
    >
      <span className="mr-2 layout_type-label">{t('reportLayout')}</span>
      <ReportLayoutIcon layoutType={layoutType} />
    </Button>
  );
};

export default ReportLayoutButton;
